import { M8CompanySize } from 'services/production/types';
import { OrgStaffCount } from 'types/orgInfoTypes';
import { UnreachableError } from 'utils/errors';

export const normalizeOrgStaffCount = (staffCount: OrgStaffCount) => ({
  toCompanySize(): M8CompanySize {
    switch (staffCount) {
      case 'small':
        return 'TINY';
      case 'medium':
        return 'MIDDLE';
      case 'large':
        return 'LARGE';
      default:
        throw new UnreachableError(staffCount);
    }
  },
});
